import React, { useState } from 'react'
import { useKeenSlider } from 'keen-slider/react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useStyles from '../../styles'

const InstagramPreviewCarousel = ({ mediaItems, renderMediaItem }) => {
  const classes = useStyles()

  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    }
  })

  return (
    <div className={classes.postMediaCarouselContainer}>
      <div ref={sliderRef} className="keen-slider">
        {mediaItems.map((mediaItem, index) => (
          <div className="keen-slider__slide" key={index}>
            {renderMediaItem(mediaItem)}
          </div>
        ))}
      </div>
      {loaded && instanceRef.current && (
        <div className={classes.postMediaCarouselDotsContainer}>
          {[...Array(instanceRef.current.track.details.slides.length).keys()].map(idx => {
            return (
              <div
                key={idx}
                className={classnames(classes.postMediaCarouselDot, {
                  active: currentSlide === idx
                })}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

InstagramPreviewCarousel.propTypes = {
  mediaItems: PropTypes.array.isRequired,
  renderMediaItem: PropTypes.func.isRequired
}

export default InstagramPreviewCarousel
